import { ParseResult, IParseResult, ValueType } from '../FormatterTypes';
import { BaseValidator } from './BaseValidator';

class TEDValidateDefault extends BaseValidator {
  public static getInstance(): BaseValidator {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: BaseValidator;

  defaultParams(): string {
    return '';
  }

  validate(value: ValueType, params?: string): IParseResult {
    return { value: true, result: ParseResult.OK };
  }
}

export { TEDValidateDefault };
